import { useCallback, useEffect, useRef } from "react";

export const useDebaunce = ({ fn, delay }) => {
  const timeoutRef = useRef(null);
  const fnRef = useRef(fn);
  fnRef.current = fn;
  useEffect(() => () => window.clearTimeout(timeoutRef.current), []);

  return useCallback(
    (...params) => {
      window.clearTimeout(timeoutRef.current);
      timeoutRef.current = window.setTimeout(() => {
        fnRef.current(...params);
      }, delay);
    },
    [delay]
  );
};
